import "./bigFooter.scss";